import type { FaireProductEntity } from "../../entity_types/product";

export const p_eq64uy67k2: FaireProductEntity = {
  token: "p_eq64uy67k2",
  type: "product",
  name: "Pocket Detail Loose Fit Knit Cardigan",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/11e4c2b2c50e4b60befde3f5786d2e57a0569108a6e9a541ca8eac39ed309bb4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/58bbe58b81c9fdfaae0014b8a83983463eb70e3d1dccb4c21491f4799c1b28d3.jpeg",
    "https://cdn.faire.com/fastly/9c5316e1a516a1d9b4fded0b3ce36c931f4001a2e850acea8f98c4934ae563c8.jpeg",
    "https://cdn.faire.com/fastly/69f015dcac2cfabb0cab03e2b7197af422993788058ecfebed14c999ebefbb1d.jpeg",
    "https://cdn.faire.com/fastly/c11da156e8fb5fc7e210c4cab530748769fea794283b10ed523b2241fac8b792.png",
  ],
  priceDollars: 40,
  description:
    "EXPERIENCE THE ULTIMATE IN COMFORT AND VERSATILITY WITH THIS LOOSE-FIT KNIT CARDIGAN, FEATURING CONVENIENT POCKETS AND A SOFT, COZY CONSTRUCTION FOR EFFORTLESS STYLING.\n\nIMPORTED, DESIGNED IN USA\n\nRELAXED LOOSE FIT AND OPEN FRONT\n\nFUNCTIONAL POCKETS AND ALLOVER KNIT TEXTURE\n\nCONT 100% ACRYLIC\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nShips from China. All Tax and duty covered",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:32.659Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
